var render = function render(){var _vm=this,_c=_vm._self._c;return _c('create-edit-user',{attrs:{"isEdit":false,"cancelRoute":'Users'}})
}
var staticRenderFns = []

export { render, staticRenderFns }